import type { ReactNode } from "react";
import { useIntl } from "react-intl";

/** Shared by profile and Match: preview a skill without moving the controls below the diagram. */
export function SkillPreviewSlot({ preview, children, className = "" }: {
  preview?: string | null; children: ReactNode; className?: string;
}) {
  const intl = useIntl();
  return <div className={`relative flex min-w-0 flex-1 flex-wrap items-center gap-1.5 ${className} ${preview ? "[&>*:not([data-skill-preview])]:invisible" : ""}`}>
    {children}
    {preview ? <div data-skill-preview className="pointer-events-none absolute inset-0 flex items-center">
      <span role="status"
        aria-label={intl.formatMessage({ id: "profile.skills.previewNamed", defaultMessage: "Preview: {name}" }, { name: preview })}
        className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-dashed border-ink-ui px-2 py-0.5 text-smycles-label text-ink">
        <span className="truncate">{preview}</span>
        <span className="shrink-0 text-ink-muted">{intl.formatMessage({ id: "profile.skills.preview", defaultMessage: "Preview" })}</span>
      </span>
    </div> : null}
  </div>;
}
